/**
 * Announcement Bar Stacked - Independent dismiss functionality for stacked banners
 * Each announcement can be dismissed independently using localStorage
 */

class AnnouncementBarStacked extends HTMLElement {
  constructor() {
    super();
    this.container = this.querySelector('.announcement-bar-stacked__container');
    this.banners = this.querySelectorAll('.announcement-bar-stacked__banner[data-dismissible="true"]');
    this.storageKeyPrefix = 'announcement_dismissed_';
  }

  connectedCallback() {
    if (!this.banners || this.banners.length === 0) {
      return;
    }

    this.initBanners();
    this.attachEventListeners();
  }

  initBanners() {
    let visibleCount = 0;

    this.banners.forEach((banner) => {
      const announcementId = banner.getAttribute('data-announcement-id');
      if (!announcementId) {
        return;
      }

      const storageKey = this.storageKeyPrefix + announcementId;
      const isDismissed = localStorage.getItem(storageKey) === 'true';

      if (isDismissed) {
        banner.setAttribute('data-dismissed', 'true');
        banner.style.display = 'none';
      } else {
        banner.style.display = 'flex';
        visibleCount++;
      }
    });

    // Hide entire announcement bar if all banners are dismissed
    if (visibleCount === 0 && this.container) {
      this.style.display = 'none';
    } else {
      this.style.display = 'block';
    }
  }

  attachEventListeners() {
    const closeButtons = this.querySelectorAll('.announcement-bar-stacked__close');

    closeButtons.forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.handleDismiss(button);
      });
    });
  }

  handleDismiss(button) {
    const announcementId = button.getAttribute('data-announcement-id');
    if (!announcementId) {
      return;
    }

    const storageKey = this.storageKeyPrefix + announcementId;
    const banner = button.closest('.announcement-bar-stacked__banner');

    if (!banner) {
      return;
    }

    // Store dismiss state in localStorage
    try {
      localStorage.setItem(storageKey, 'true');
    } catch (e) {
      console.error('Failed to save dismiss state:', e);
    }

    // Hide the banner
    banner.setAttribute('data-dismissed', 'true');
    banner.style.display = 'none';

    // Check if all banners are now dismissed
    const visibleBanners = Array.from(this.banners).filter(
      (b) => b.getAttribute('data-dismissed') !== 'true'
    );

    if (visibleBanners.length === 0) {
      this.style.display = 'none';
    }
  }
}

customElements.define('announcement-bar-stacked', AnnouncementBarStacked);

